import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { useEffect, useState } from "react"
import './ProgressBar.css'
import socket from '../../socket/socket'
import { captureException } from '@sentry/browser';


const steps = {'rc_deploy' : {"label" : 'Build RC env' , "index" : 0}, 
              'rc_automation' : {"label" :  'Run tests' , "index" : 1},
              'prod_deploy' : {"label" : 'Deploy prod', "index" : 2}
              };

export default function ProgressBar() {

  const[current_status,set_current_status] = useState('success')
  const[current_job,set_current_job] = useState('rc_automation')
  const [activeStep,set_activeStep] = useState(0)
  
  useEffect(() => {
    var options = {
        'method': 'POST',
        'url': process.env.REACT_APP_INFRA_SERVICE_URL+"/releaseProgress/get_jobs_status/" ,
        'headers': {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify({
    })


    };
    fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/releaseProgress/get_jobs_status/" , options).then(response=>response.json())
    .then(async data=>{ 
      if (data.err){
        const event_id = captureException(data.err);
        console.log('error logged', { event_id }); 
      }
      set_current_job(data.current_job)
      set_current_status(data.current_status)
      set_activeStep(steps[current_job].index)
      if(data.current_status?.includes("success") || data.current_status=="failed"){
        set_activeStep(steps[data.current_job].index+0.5)
      }
    });  
  },[] );

  useEffect( () => {
    socket.on('update_job_status', function(inputs) {
      set_current_status(inputs[1])
      set_current_job(inputs[0])
      set_activeStep(steps[inputs[0]].index)
      if(inputs[1].includes("success") || inputs[0]=="failed"){
        set_activeStep(steps[current_job].index+0.5)
      }
    });
      
  },[])
    return (
        <Box sx={{ width: '100%' }}>

        <Stepper activeStep={activeStep}>
        {Object.entries(steps).map(([step, value]) => {
          
            return(
              
                <Step key={steps[step].label}>
                    <StepLabel 
                        error={step===current_job && current_status=="failed" ? true : false} 
                        key={steps[step].label} 
                        className={`blink ${step==current_job && current_status== "in_progress"? "active" : ""}`} >
                      {steps[step].label} 
                    </StepLabel>
                </Step>
            );
            })}
            
        </Stepper>
        </Box>
    );
}
